<template>
  <div class="gate">
    <div v-if="mode === 'blocked'" class="gate-card">
      <p class="gate-kicker">算力百科 · 管理后台</p>
      <h1>无访问权限</h1>
      <p class="gate-desc">此页面仅管理员可使用。当前账号角色为「{{ roleLabel }}」。</p>
      <div class="gate-actions">
        <router-link class="btn primary" to="/">返回首页</router-link>
        <router-link class="btn ghost" to="/account">切换账号</router-link>
      </div>
    </div>
    <div v-else class="gate-card">
      <p class="gate-kicker">算力百科 · 管理后台</p>
      <h1>管理员登录</h1>
      <p class="gate-desc">仅运营人员可进入。请使用管理密码，勿使用访客验证码。</p>
      <form class="login-form" @submit.prevent="$emit('login')">
        <label>
          <span>管理密码</span>
          <input
            :value="modelValue"
            type="password"
            autocomplete="current-password"
            placeholder="输入管理密码"
            @input="$emit('update:modelValue', $event.target.value)"
          />
        </label>
        <button class="btn primary block" type="submit">进入后台</button>
        <p v-if="error" class="error">{{ error }}</p>
      </form>
      <router-link class="back-link" to="/">← 返回首页</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminGate',
  props: {
    mode: { type: String, default: 'login' },
    roleLabel: { type: String, default: '' },
    modelValue: { type: String, default: '' },
    error: { type: String, default: '' }
  },
  emits: ['login', 'update:modelValue']
}
</script>
